import Typography from '@classify/react-core-components/Typography';
import withStyles from '@mui/styles/withStyles';

import { palette } from '../../../theme';

import styles from './styles';

export const ListItem = ({
  overlineLabel = '',
  overlineLabelColor = palette.text.caption,
  children = '',
  classes = {},
  className = '',
  component: Component = 'li',
  illustration,
  shouldHandleHover = false,
  sublineLabel = null,
  title,
  titleProps = {},
  titleComponent = null,
  ...otherProps
}) => (
  <Component className={`${className} ${classes.root}`} {...otherProps}>
    <div
      className={`${classes.listItemInner} ${shouldHandleHover ? classes.listItemInnerHover : ''}`}
    >
      <div
        className={classes.illustrationContainer}
        style={{ backgroundColor: overlineLabelColor }}
      >
        {illustration}
      </div>
      <div className={classes.informationContainer}>
        {overlineLabel && (
          <Typography
            className={classes.overlineLabel}
            variant="overline"
            style={{ color: overlineLabelColor }}
          >
            {overlineLabel}
          </Typography>
        )}

        <Typography
          className={classes.title}
          variant="h6"
          component={titleComponent}
          sx={{ display: 'block' }}
          {...titleProps}
        >
          {title}
        </Typography>

        {sublineLabel && <div className={classes.sublineLabel}>{sublineLabel}</div>}

        {typeof children === 'string' && (
          <Typography className={classes.content} variant="body1">
            {children}
          </Typography>
        )}

        {typeof children !== 'string' && <div className={classes.content}>{children}</div>}
      </div>
    </div>
  </Component>
);

export default withStyles(styles)(ListItem);
